import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder: {
    id: 'components.atom.emailAutcomplete.defaultPlaceholder',
    defaultMessage: 'Enter your email',
  },
});
